interface LoadingSpinnerProps {
  message: string
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="max-w-md w-full text-center">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-foreground"></div>
        <div className="text-lg font-semibold">{message}</div>
      </div>
    </div>
  )
}

